import { render } from "./MovePanel.vue?vue&type=template&id=1e6838d4&scoped=true"
import script from "./MovePanel.vue?vue&type=script&lang=js"
export * from "./MovePanel.vue?vue&type=script&lang=js"

import "./MovePanel.vue?vue&type=style&index=0&id=1e6838d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6838d4"]])

export default __exports__